import { render, staticRenderFns } from "./ProgramDetails.vue?vue&type=template&id=94b1e162&scoped=true&"
import script from "./ProgramDetails.vue?vue&type=script&lang=ts&"
export * from "./ProgramDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramDetails.vue?vue&type=style&index=0&id=94b1e162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b1e162",
  null
  
)

export default component.exports